<template>
  <el-dialog
    v-model="dialogVisible"
    width="700px"
    @close="handleClose"
    destroy-on-close append-to-body
    class="booking-dialog-container"
  >
    <template #header>
      <div flex items-center text-size-16px fw-600>
        <el-icon size="20px" color="#0052D9"><WarningFilled /></el-icon>
        <span ml-8px>预定管理</span>
      </div>
    </template>
    <div class="booking-content" v-if="hasConfiguredTables" flex>
      <template v-if="tableReservationList.length > 0">
        <div flex flex-col>
          <div
            bg="#F3F3F3"
            cursor="pointer"
            mb-8px
            h-24px
            flex
            items-center
            justify-center
            b-rd-3px
            @click="handleChangeDate(-7)"
          >
            <el-icon><ArrowUpBold /></el-icon>
          </div>
          <div
            :class="activatedIndex === index ? 'booking-date-item active' : 'booking-date-item'"
            v-for="(item, index) in tableReservationList"
            :key="item.date"
            @click="handleSelectDate(index)"
          >
            <span text-size-14px>{{ item.date }} {{ getWeekDay(new Date(`${new Date().getFullYear()}-${item.date}`)) }}</span>
            <span mt-4px class="booking-number-text">已预订：{{ item.reservationTotal }}单</span>
          </div>
          <div
            bg="#F3F3F3"
            cursor="pointer"
            mt-8px
            h-24px
            flex
            items-center
            justify-center
            b-rd-3px
            @click="handleChangeDate(7)"
          >
            <el-icon><ArrowDownBold /></el-icon>
          </div>
        </div>
        <div v-if="tableReservationList[activatedIndex].combinedReservations.length > 0" class="resercation-list" w-600px>
          <el-collapse accordion ml-14px>
            <el-collapse-item
              class="resercation-item"
              v-for="value in tableReservationList[activatedIndex].combinedReservations"
              :key="String(value.reserveId)"
            >
              <template #title>
                <div class="resercation-item-title" flex items-center justify-start pl-16px pr-16px text-size-14px>
                  <span>{{ dayjs(value.startTime).format("HH:mm") }}</span>
                  <span ml-16px>{{ value.booker }}</span>
                  <span ml-16px>{{ value.contact }}</span>
                  <span
                    ml-16px
                    color="#00000042"
                    style="width: 100px; overflow: hidden; text-overflow: ellipsis; text-align: center"
                  >{{ getTableType(value) }}</span>
                  <span ml-a :color="!value.isReserved ? '#BF0B0E' : ''" style="text-align: right">{{
                    computeStatus(value.status as number, value.isReserved as boolean)
                  }}</span>
                </div>
              </template>
              <div class="resercation-item-content">
                <div flex flex-col items-start justify-start>
                  <span>预订人：{{ value.booker }}</span>
                  <span>联系电话：{{ value.contact }}</span>
                  <span>预抵时间：{{ dayjs(value.startTime).format("YYYY-MM-DD HH:mm") }}</span>
                  <span v-if="value.isReserved">未到店自动取消时间：{{ reservationDeadlineText(value) }}</span>
                  <span>预定桌台：{{
                    !value.isReserved ? getTableType(value) : getTableName(value.reserveTableId as number)
                  }}</span>
                  <span v-if="getRemark(value)">备注：{{ getRemark(value) }}</span>
                </div>
                <div
                  v-if="value.status == 1 || value.status == 2"
                  color="#0052D9"
                  cursor="pointer"
                  mt-18px
                  flex
                  select-none
                  class="button-group"
                >
                  <el-button v-if="value.isReserved" type="primary" text @click="handleResercationOpen(value)">预订开台</el-button>
                  <el-button v-if="canUseLegacyReservationActions(value)" type="primary" text @click="handleEditResercation(value)">{{ value.isReserved ? "修改预订" : "选择桌台" }}</el-button>
                  <el-popconfirm
                    width="380px"
                    :title="getCancleTips(value)"
                    cancel-button-text="暂不"
                    @confirm="handleCancleResercation(value)"
                    v-if="value.isReserved && canUseLegacyReservationActions(value)"
                  >
                    <template #reference>
                      <el-button type="danger" text>取消预订</el-button>
                    </template>
                  </el-popconfirm>
                  <el-button v-if="!value.isReserved" @click="handleRefuseResercation(value)" type="danger" text>拒绝预订</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div v-else w-500px flex items-center justify-center>
          <el-empty description="当前日期暂无预订，可点击下方新增预订" />
        </div>
      </template>
      <div v-else class="booking-empty-container" w-full flex items-center justify-center>
        <el-empty description="暂无预订，可点击下方新增预订" />
      </div>
    </div>
    <div v-else>
      <el-empty description="您还未设置桌台，请点击 “设置 > 桌台管理” 设置桌台" />
    </div>
    <template #footer>
      <el-button v-if="canAddBooking" class="order-button" :disabled="!hasConfiguredTables" @click="handleBooking">新增预订</el-button>
    </template>
  </el-dialog>
  <!-- refresh刷新数据,update:show关闭窗口 -->
  <EditBookingDialog
    :show="showEditDialog"
    :table-reservation-info="tableReservationInfo"
    @refresh="handleRefresh"
    v-if="showEditDialog"
    @update:show="showEditDialog = $event"
  />
  <RejectDialog
    :show="showRejectDialog"
    :customerReserveId="customerReserveId"
    v-if="showRejectDialog"
    @refresh="handleRefresh"
    @update:show="showRejectDialog = $event"
  />
</template>

<script lang="ts" setup>
import type {
  MerchantOmsCustomerReservationWithIsReserved,
  MerchantOmsTableReservationWithIsReserved,
  OldMerchantTableReservationDTOWithCombinedReservations,
  OldUnionReservation,
  ReserveTableCategoryDO,
  UnionReservation,
} from "@/api/business/types/table"
import { useVModel } from "@vueuse/core"
import dayjs from "dayjs"
import { ElMessage } from "element-plus"
import { computed, ref } from "vue"
import { cancelTableReservation, getTableReservationList } from "@/api/business/table"
import { useTableStore } from "@/store/modules/table"
import { useUserStore } from "@/store/modules/user"
import RejectDialog from "@/views/page/business/components/Booking/RejectDialog.vue"
import EditBookingDialog from "./EditBookingDialog.vue"
import { canUseLegacyReservationActions, isSmartOmsReservation } from "./legacyReservationActions"
import { reservationDeadlineText } from "./reservationDeadline"

const emit = defineEmits(["update:modelValue", "refresh", "openTable"])

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
})

const userStore = useUserStore()
const tableStore = useTableStore()
const { fetchOpeningTableListV2, setRefreshReservationFlag } = tableStore
const openingTableList = tableStore.getOpeningTableList()
const shopId = userStore.shopId
const dialogVisible = useVModel(props, "modelValue", emit, { passive: true })
const tableReservationList = ref<OldMerchantTableReservationDTOWithCombinedReservations[]>([])
const activatedIndex = ref(0)
const showEditDialog = ref(false)
const tableReservationInfo = ref<OldUnionReservation>()
const date = ref(new Date())
const hasConfiguredTables = computed(() => openingTableList.length > 0)
const canAddBooking = computed(() => userStore.checkPermission("business_booking_add"))

const showRejectDialog = ref(false)
const customerReserveId = ref(0)

const computeStatus = (status: number, isReserved: boolean) => {
  if (!isReserved) {
    switch (status) {
      case 1:
        return "待确认"
      case 2:
        return "已同意"
      case 3:
        return "已取消"
      case 4:
        return "已拒绝"
    }
  }
  switch (status) {
    case 1:
      return "未到店"
    case 2:
      return "未到店"
    case 3:
      return "已退订"
    case 4:
      return "已到店"
    default:
      return ""
  }
}

const getTableName = (tableId: number) => {
  const table = openingTableList.find((item) => item.tableId === tableId)
  return table ? table.tableName : ""
}

const getCancleTips = (value: UnionReservation) => {
  return `您确认取消【${value.booker}】${dayjs(value.startTime).format("YYYY/MM/DD HH:mm")}的预定吗？`
}

const handleClose = () => {
  dialogVisible.value = false
}

const handleBooking = () => {
  if (!userStore.checkPermission("business_booking_add")) {
    ElMessage.error("您没有权限新增预订")
    return
  }
  tableReservationInfo.value = undefined
  showEditDialog.value = true
}

const handleSelectDate = (index: number) => {
  activatedIndex.value = index
}

const handleChangeDate = (number: number) => {
  const newDate = new Date(date.value)
  newDate.setDate(newDate.getDate() + number)
  date.value = newDate
  fetchTableReservationList()
  activatedIndex.value = 0
}

const fetchTableReservationList = async () => {
  const res = await getTableReservationList(shopId, date.value)
  if (res.code !== 0) {
    ElMessage.error(res.msg)
    return
  }
  const data = res.data
  data.forEach((item) => {
    // 把list中的customerReservation和reservations根据时间排序合并到reservations ,临时
    item.reservations.forEach((item: MerchantOmsTableReservationWithIsReserved) => {
      item.isReserved = true
    })
    item.customerReservations.forEach((item: MerchantOmsCustomerReservationWithIsReserved) => {
      item.isReserved = false
    })
    // 过滤出没完成的预订
    item.customerReservations = item.customerReservations.filter((item) => item.status == 1)
  })
  tableReservationList.value = data.map((item) => {
    return {
      ...item,
      combinedReservations: [...item.reservations, ...item.customerReservations].sort((a, b) => {
        return new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
      }),
    } as OldMerchantTableReservationDTOWithCombinedReservations
  })
}

const handleRefresh = () => {
  fetchTableReservationList()
}

const handleCancleResercation = async (cancelReservationInfo: OldUnionReservation) => {
  if (!cancelReservationInfo.isReserved || isSmartOmsReservation(cancelReservationInfo)) {
    ElMessage.error("请在预订工作台取消预订")
    return
  }
  if (!userStore.checkPermission("business_booking_cancel")) {
    ElMessage.error("您没有权限取消预订")
    return
  }
  const reserveId = cancelReservationInfo.reserveId
  if (typeof reserveId !== "number") {
    ElMessage.error("预订记录不存在")
    return
  }
  await cancelTableReservation(reserveId).then((res) => {
    if (res.code !== 0) {
      ElMessage.error(res.msg)
      return
    }
    ElMessage.success("取消成功")
    setRefreshReservationFlag(true)
    fetchOpeningTableListV2()
    fetchTableReservationList()
    emit("refresh")
  })
}
// 拒绝C端客户预订
const handleRefuseResercation = async (value: UnionReservation) => {
  showRejectDialog.value = true
  if ("customerReserveId" in value) {
    customerReserveId.value = value.customerReserveId!
  }
}

const handleEditResercation = (editTableReservationInfo: OldUnionReservation) => {
  if (isSmartOmsReservation(editTableReservationInfo)) {
    ElMessage.error("请在预订工作台修改预订")
    return
  }
  if (!userStore.checkPermission("business_booking_update")) {
    ElMessage.error("您没有权限修改预订")
    return
  }
  showEditDialog.value = true
  tableReservationInfo.value = editTableReservationInfo
}

const handleResercationOpen = (openTableReservationInfo: UnionReservation) => {
  handleClose()
  emit("openTable", openTableReservationInfo)
}

const getWeekDay = (date: Date) => {
  const weekDay = date.getDay()
  if (date.getDate() == new Date().getDate()) {
    return "今天"
  }
  switch (weekDay) {
    case 0:
      return "周日"
    case 1:
      return "周一"
    case 2:
      return "周二"
    case 3:
      return "周三"
    case 4:
      return "周四"
    case 5:
      return "周五"
    case 6:
      return "周六"
    default:
      return ""
  }
}
// 获取预订桌台信息
const getTableType = (val: UnionReservation) => {
  const tableTypeList: string[] = []
  if (!val) {
    return ""
  }
  if ("reserveTableCategoryId" in val) {
    const reserveTableCategoryId = val.reserveTableCategoryId
    reserveTableCategoryId.forEach((item: ReserveTableCategoryDO) => {
      tableTypeList.push(`${item.name}${item.count}`)
    })
  }
  return tableTypeList.join(",")
}

// 获取备注信息
const getRemark = (val: UnionReservation) => {
  if ("remark" in val) {
    return val.remark
  }
  if ("bookerRemark" in val) {
    return val.bookerRemark
  }
  return ""
}
fetchTableReservationList()
</script>

<style scoped lang="scss">
.booking-dialog-container {
  .booking-content {
    padding-bottom: 16px;
    border-bottom: 1px solid var(--tea-color-border-subtle);

    .booking-date-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100px;
      padding: 10px 8px;
      color: var(--tea-color-text-secondary);
      cursor: pointer;
      user-select: none;
      background: var(--tea-color-fill-subtle);
      border-left: 1px solid var(--tea-color-border-subtle);
    }

    .active {
      color: var(--tea-color-primary);
      background: var(--tea-color-bg-elevated);
      border-left: 4px solid var(--tea-color-primary);
    }

    .resercation-list {
      height: 500px;
      padding-right: 8px;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-track {
        background-color: var(--tea-color-bg-surface);
      }

      &::-webkit-scrollbar-thumb {
        background: var(--tea-color-scrollbar-thumb);
        border-radius: 4px;
      }

      .resercation-item {
        border-right: 1px solid var(--tea-color-border-subtle);
        border-left: 1px solid var(--tea-color-border-subtle);

        .resercation-item-title {
          width: 100%;

          span {
            display: inline-block;
            min-width: 15%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .resercation-item-content {
          width: 100%;
          padding: 12px 40px 18px;
          font-size: 12px;
          color: var(--tea-color-text-regular);
          background: var(--tea-color-fill-subtle);

          .button-group {
            display: flex;
            justify-content: start;
          }
        }
      }
    }
  }

  .order-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    padding: 12px 32px;
    margin-left: auto;
    font-size: 20px;
    color: var(--tea-component-order-action-text-color);
    user-select: none;
    background: var(--tea-component-order-action-bg);
    border: 1px solid var(--tea-component-order-action-border-color);
    border-radius: 8px;
    box-shadow: var(--tea-component-order-action-shadow);
  }
}
</style>
